import * as types from './types';

export const showGlobalNotification = (type, message) => ({
  type: types.SHOW_GLOBAL_NOTIFICATION,
  payload: {
    type,
    message
  }
});

export const hideGlobalNotification = () => ({
  type: types.HIDE_GLOBAL_NOTIFICATION,
});
